import { createFileRoute, redirect } from "@tanstack/react-router";
import Header from "@/components/Header";
import Hero from "@/components/landingPage/Hero";
import WhyKidsLoveBooq from "@/components/landingPage/WhyKidsLoveBooq";
import WhyParentsLoveBooq from "@/components/landingPage/WhyParentsLoveBooq";
// TODO: Re-enable when features section is ready
// import FeaturesSection from "@/components/landingPage/FeaturesSection";
import FooterCta from "@/components/FooterCta";
import Footer from "@/components/Footer";
import { ScrollGradient, ScrollHint } from "@/components/ScrollHint";
import { isAuthenticated, pb } from "@/lib/pocketbase";

const LandingPage = () => {
  return (
    <>
      <ScrollHint />
      <ScrollGradient />
      <Header />
      <Hero />
      <WhyKidsLoveBooq />
      <WhyParentsLoveBooq />
      {/* <FeaturesSection /> */}
      <FooterCta />
      <Footer />
    </>
  );
};

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    // Redirect authenticated users with complete profiles to dashboard
    if (isAuthenticated()) {
      const user = pb.authStore.model;
      // Only redirect if user has completed their profile
      if (user?.birthdate && user?.gender) {
        console.log('✅ Authenticated user with complete profile, redirecting to dashboard');
        throw redirect({
          to: '/dashboard',
        });
      }
    }
  },
  component: LandingPage,
});
